import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'
import { ArchiveGivingActionError, useArchiveGivingAction } from './useArchiveGivingAction'

export type ArchiveGivingActionModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
  givingAction: {
    id: string
    name: string
  } | null
  onSuccess: () => void
  onError: (error?: ArchiveGivingActionError) => void
}>

export function ArchiveGivingActionModal({
  isOpen,
  handleClose,
  givingAction,
  onSuccess,
  onError
}: ArchiveGivingActionModalProps) {
  const { t } = useTranslation()

  const { isLoading, archiveGivingAction } = useArchiveGivingAction({
    actionId: givingAction?.id,
    onArchived: onSuccess,
    onError
  })

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="archive-giving-action">
      <ActionModal
        title={t('dialog.givingActions.archive.title')}
        primaryButtonText={t('button.archiveGivingAction')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={archiveGivingAction}
        loading={isLoading}
        primaryBtnTestId="archive-giving-action-confirm-button"
      >
        <Trans
          i18nKey="dialog.givingActions.archive.description"
          components={{ b: <b /> }}
          values={{ actionName: givingAction?.name ?? '' }}
        />
      </ActionModal>
    </Modal>
  )
}
